import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isMarkMilestoneAsCompletedRequestFailure({ uuid }) {
      const milestoneState = getState().find(
        (state) => state.milestone.uuid === uuid,
      );

      return milestoneState ? milestoneState.request.isFailure : false;
    },
    isMarkMilestoneAsCompletedRequestPending({ uuid }) {
      const milestoneState = getState().find(
        (state) => state.milestone.uuid === uuid,
      );

      return milestoneState ? milestoneState.request.isPending : false;
    },
    isMarkMilestoneAsCompletedRequestSuccess({ uuid }) {
      const milestoneState = getState().find(
        (state) => state.milestone.uuid === uuid,
      );

      return milestoneState ? milestoneState.request.isSuccessful : false;
    },
  };
}

export { createSelector };
